// Chart layout keys
export const DEFAULT_LAYOUT_KEY = 'default'
export const AUTOMOTIVE_LAYOUT_KEY = 'automotive'

export const MOBILE_TYPE_LAYOUT_KEY = 'mobile'
export const DEFAULT_TYPE_LAYOUT_KEY = 'default'
